<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('gasolineras')">Gasolineras</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> Agregar
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.nombre" :error="form.errors.nombre" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre" required />
          <text-input v-model="form.orden" :error="form.errors.orden" class="pr-6 pb-8 w-full lg:w-1/4" label="Orden en listas" type="number" />
          <select-input v-model="form.activo" :error="form.errors.activo" class="pr-6 pb-8 w-full lg:w-1/4" label="Estado">
            <option :value="true">Activa</option>
            <option :value="false">Inactiva</option>
          </select-input>
          <text-input v-model="form.precio_diesel" :error="form.errors.precio_diesel" class="pr-6 pb-8 w-full lg:w-1/3" label="Precio Diesel" type="number" step="0.0001" min="0" required />
          <text-input v-model="form.precio_extra" :error="form.errors.precio_extra" class="pr-6 pb-8 w-full lg:w-1/3" label="Precio Extra" type="number" step="0.0001" min="0" required />
          <text-input v-model="form.precio_super" :error="form.errors.precio_super" class="pr-6 pb-8 w-full lg:w-1/3" label="Precio Super" type="number" step="0.0001" min="0" required />
          <select-input v-model="form.documento_editable" :error="form.errors.documento_editable" class="pr-6 pb-8 w-full lg:w-1/2" label="Nº Documento en despachos">
            <option :value="true">Se escribe en cada despacho</option>
            <option :value="false">Fijo</option>
          </select-input>
          <text-input v-model="form.numero_documento" :error="form.errors.numero_documento" class="pr-6 pb-8 w-full lg:w-1/2" :label="form.documento_editable ? 'Nº Documento sugerido' : 'Nº Documento fijo'" :required="!form.documento_editable" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Crear Gasolinera</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Agregar Gasolinera' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nombre: '',
        precio_diesel: '',
        precio_extra: '',
        precio_super: '',
        numero_documento: '',
        documento_editable: true,
        orden: '0',
        activo: true,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('gasolineras.store'))
    },
  },
}
</script>
